import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconLogin: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.125 5V15C18.125 17.015 17.015 18.125 15 18.125H10C7.985 18.125 6.875 17.015 6.875 15V14.1667C6.875 13.8217 7.155 13.5417 7.5 13.5417C7.845 13.5417 8.125 13.8217 8.125 14.1667V15C8.125 16.3142 8.68583 16.875 10 16.875H15C16.3142 16.875 16.875 16.3142 16.875 15V5C16.875 3.68583 16.3142 3.125 15 3.125H10C8.68583 3.125 8.125 3.68583 8.125 5V5.83333C8.125 6.17833 7.845 6.45833 7.5 6.45833C7.155 6.45833 6.875 6.17833 6.875 5.83333V5C6.875 2.985 7.985 1.875 10 1.875H15C17.015 1.875 18.125 2.985 18.125 5ZM10.3916 12.0583C10.1475 12.3025 10.1475 12.6983 10.3916 12.9425C10.5133 13.0642 10.6733 13.1258 10.8333 13.1258C10.9933 13.1258 11.1534 13.065 11.275 12.9425L13.775 10.4425C13.8325 10.385 13.8783 10.3158 13.91 10.2392C13.9733 10.0867 13.9733 9.91416 13.91 9.76166C13.8783 9.68499 13.8325 9.61583 13.775 9.55833L11.275 7.05833C11.0309 6.81417 10.635 6.81417 10.3908 7.05833C10.1467 7.3025 10.1467 7.69834 10.3908 7.9425L11.8242 9.37584H2.5C2.155 9.37584 1.875 9.65584 1.875 10.0008C1.875 10.3458 2.155 10.6258 2.5 10.6258H11.8242L10.3916 12.0583Z"
      fill={color}
    />
  </svg>
);

export default IconLogin;
